import { Box, FlexLayout, H4, Icon } from '@deity/falcon-ui'; // '@deity-io/portal-ui';
import { Tooltip } from 'components';
import type { FC } from 'react';
import ReactJson from 'react-json-view';

interface IJsonEditorProps {
  locked?: boolean;
  label?: string;
  description?: string;
  value: {};
  error?: boolean;
  toolIcons?: any;
  onUpdate?: (val: {}) => void;
}
export const JSONEditor: FC<IJsonEditorProps> = ({ locked, label, description, value, onUpdate, error, toolIcons }) => (
  <FlexLayout
    p="xs"
    mt="xs"
    mb="xs"
    bg="panelLight"
    borderRadius="small"
    css={{ minHeight: '78px' }}
    width="full"
    flexDirection="column"
  >
    <FlexLayout alignItems="center" width="full">
      <FlexLayout width="full" alignItems="center" justifyContent="space-between">
        {label && (
          <H4 fontWeight="bold" mr="xs" style={{ textTransform: 'capitalize' }}>
            {label}
          </H4>
        )}
        {toolIcons && <Box style={{ marginRight: '0px' }}>{toolIcons}</Box>}
        {description && (
          <Tooltip content={description} direction="left">
            <Icon src="helpOutline" color="secondary" stroke="transparent" />
          </Tooltip>
        )}
      </FlexLayout>
    </FlexLayout>
    <ReactJson
      enableClipboard={false}
      name={null}
      src={value}
      onEdit={e => {
        if (locked) {
          return;
        }
        if (e.existing_src !== e.updated_src) {
          if (onUpdate) {
            onUpdate(e.updated_src);
          }
        }
        if (e.new_value === 'error') {
          return false;
        }
      }}
      onDelete={e => {
        if (locked) {
          return;
        }
        if (e.existing_src !== e.updated_src) {
          if (onUpdate) {
            onUpdate(e.updated_src);
          }
        }
      }}
      onAdd={e => {
        if (locked) {
          return;
        }
        if (e.existing_src !== e.updated_src) {
          if (onUpdate) {
            onUpdate(e.updated_src);
          }
        }
        if (e.new_value === 'error') {
          return false;
        }
      }}
    />
  </FlexLayout>
);
